export enum PhoneNumberVerifyErrorCodes {
  PHONE_VERIFIED = 'phone_verified',
  WRONG_PHONE_OTP = 'wrong_phone_otp',
}

export enum CheckDuplicateEmailErrorCodes {
  EMAIL_EXISTING = 'email_existing',
  EMAIL_IS_UNIQUE = 'email_is_unique',
}

export enum EmailVerifyErrorCodes {
  EMAIL_VERIFIED = 'email_verified',
  WRONG_EMAIL_OTP = 'wrong_email_otp',
}
